<template>
  <div id="app" class="container-fluid">
    <div class="col-md-9 panel panel-default">
      <tree
        ref="tree"
        :identifier="getId"
        :zoomable="zoomable"
        :data="treeData"
        :node-text="nodeText"
        :margin-x="MarginY"
        :margin-y="MarginY"
        :radius="radius"
        :type="type"
        :layout-type="layoutType"
        :duration="duration"
        @clickedText="onClick"
        @expand="onExpand"
        @retract="onRetract"
        @clickedNode="onClickNode"
        :class="$vuetify.theme.dark ? 'dark-theme tree' : 'light-theme tree'"
      >
        <template #popUp="{ data, node }">
          <v-card
            rounded="0"
            :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'"
          >
            <table
              style="
                width: 100%;
                border-collapse: collapse;
                font-size: 14px;
                border: 1px solid #162334;
              "
            >
              <tr>
                <td
                  style="
                    padding: 10px;
                    word-wrap: break-word;
                    background-color: #162334;
                    border: 1px solid #131c29;
                  "
                >
                  Ib Code:
                </td>
                <td
                  style="
                    padding: 10px;
                    word-wrap: break-word;
                    border: 1px solid #162334;
                    font-weight: bold;
                  "
                >
                  {{ data?.name }}
                </td>
              </tr>
              <tr>
                <td
                  style="
                    padding: 10px;
                    word-wrap: break-word;
                    background-color: #162334;
                    border: 1px solid #131c29;
                  "
                >
                  Name:
                </td>
                <td
                  style="
                    padding: 10px;
                    word-wrap: break-word;
                    border: 1px solid #162334;
                    font-weight: bold;
                  "
                >
                  {{ data?.info?.name }}
                </td>
              </tr>
              <tr>
                <td
                  style="
                    padding: 10px;
                    word-wrap: break-word;
                    background-color: #162334;
                    border: 1px solid #131c29;
                  "
                >
                  Reg Date:
                </td>
                <td
                  style="
                    padding: 10px;
                    word-wrap: break-word;
                    border: 1px solid #162334;
                    font-weight: bold;
                  "
                >
                  {{ formatMySQLDate(data?.info?.regDate) }}
                </td>
              </tr>
              <tr>
                <td
                  style="
                    padding: 10px;
                    word-wrap: break-word;
                    background-color: #162334;
                    border: 1px solid #131c29;
                  "
                >
                  Email:
                </td>
                <td
                  style="
                    padding: 10px;
                    word-wrap: break-word;
                    border: 1px solid #162334;
                    font-weight: bold;
                  "
                >
                  {{ data?.info?.email }}
                </td>
              </tr>
              <tr>
                <td
                  style="
                    padding: 10px;
                    word-wrap: break-word;
                    background-color: #162334;
                    border: 1px solid #131c29;
                  "
                >
                  Level:
                </td>
                <td
                  style="
                    padding: 10px;
                    word-wrap: break-word;
                    border: 1px solid #162334;
                    font-weight: bold;
                  "
                >
                  {{ data?.info?.level }}
                </td>
              </tr>
            </table>
          </v-card>
        </template>
      </tree>
    </div>
  </div>
</template>

<script>
import { DRONEVIEW__ACTIONS } from "@/store/action-types";
import { tree } from "vued3tree";
import { mapActions, mapState } from "vuex";

export default {
  name: "app",
  data() {
    return {
      duration: 750,
      radius: 5,
      leafTextMargin: 6,
      nodeTextMargin: 6,
      nodeText: "name",
      currentData: null,
      zoomable: true,
      isLoading: false,
      isUnderGremlinsAttack: false,
      nodeTextDisplay: "all",
      linkLayout: "bezier",
      minZoom: 0.8,
      maxZoom: 9,
      layoutType: "horizontal",
      currentNode: null,
      type: "tree",
      MarginX: 6,
      MarginY: 6,
      events: [],
      objData: null,
    };
  },
  components: {
    tree,
  },
  methods: {
    ...mapActions("droneview", [DRONEVIEW__ACTIONS.DRONEVIEW]),
    
  formatMySQLDate(date) {
  if (!date) return '';
  
  // Try to parse the date, whether it's ISO or already a Date object
  const parsedDate = date instanceof Date ? date : new Date(date);
  
  // Check if the date is valid
  if (isNaN(parsedDate.getTime())) return '';

  const day = parsedDate.getDate().toString().padStart(2, '0');
  const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
  const year = parsedDate.getFullYear();

  let hours = parsedDate.getHours();
  const minutes = parsedDate.getMinutes().toString().padStart(2, '0');

  const amPm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12 || 12;

  return `${day}.${month}.${year} - ${hours}:${minutes} ${amPm}`;
},
    getId(node) {
      return node.id;
    },
    onClick(evt) {
      console.log("handleClick", evt);
      this.objData = evt;
      this.currentNode = evt.element;
      this.onEvent("handleClick", evt);
    },
    onExpand(evt) {
      // console.log("handleExpand", evt);
      this.onEvent("handleExpand", evt);
    },
    onRetract(evt) {
      // console.log("handleRetract", evt);
      this.onEvent("handleRetract", evt);
    },
    onClickNode(evt) {
      // console.log("handleRetract", evt);
      this.onEvent("handleRetract", evt);
    },
    onEvent(eventName, data) {
      // console.log("onEvent", eventName, data);
      this.events.push({ eventName, data: data?.data });
    },
    addFor(data) {
      // console.log(data);
    },
    remove(data, node) {
      const parent = node.parent.data;
      removeElement(parent.children, data);
    },
  },
  computed: {
    ...mapState("droneview", ["treeData"]),
  },
  mounted() {
    this[DRONEVIEW__ACTIONS.DRONEVIEW]();
  },
};
</script>

<style>
.node {
  cursor: pointer;
}

.tree {
  width: 100%;
  height: 800px;
}

.graph-root {
  width: 100%;
  height: 800px;
}

.feedback {
  height: 50px;
  line-height: 50px;
  vertical-align: middle;
}

.log {
  height: 200px;
  overflow-x: auto;
  overflow-y: auto;
  overflow: auto;
  text-align: left;
}

.node circle {
  fill: #039de9;
  stroke: white;
  stroke-width: 2.5px;
}
.dark-theme .node circle {
  fill: #039de9;
  stroke: white;
  stroke-width: 2.5px;
}

.treeclass .nodetree text {
  font-size: 14px;
  text-shadow: none;
  fill: #039de9;
}

.dark-theme .treeclass .nodetree text {
  font-size: 24px;
  text-shadow: none;
  fill: white;
}
</style>
